import { COLLECTIONS } from "../../data/photography";
import { photoBackground } from "../../lib/photographyUtils";

function CollectionsComingSoonOverlay() {
  return (
    <div className="photo-collections-coming-soon__overlay" role="status" aria-live="polite">
      <p className="photo-collections-coming-soon__heading">COMING SOON</p>
      <p className="photo-collections-coming-soon__note">
        Sorry, not enough time during the day but I am working on this.
      </p>
    </div>
  );
}

/**
 * @param {{ onOpenCollection: (id: string) => void }} props
 */
export default function CollectionsGrid({ onOpenCollection }) {
  return (
    <section
      id="sub-collections"
      className="photo-collections photo-collections-coming-soon-shell"
      aria-label="Collections"
    >
      <div className="photo-collections__header">
        <div>
          <div className="photo-collections__heading-row">
            <span className="photo-collections__heading">COLLECTIONS</span>
            <span className="photo-collections__heading-rule" />
            <span className="photo-collections__heading-sub">STORIES, PLACES & SUBJECTS</span>
          </div>
          <p className="photo-collections__intro">
            Bodies of work organised around a theme, a journey or an event. Step inside
            to browse the full set.
          </p>
        </div>
        <span className="photo-collections__count">{COLLECTIONS.length} COLLECTIONS</span>
      </div>

      <div className="photo-collections__grid">
        {COLLECTIONS.map((collection) => (
          <button
            key={collection.id}
            type="button"
            className="photo-collection-card"
            style={{ background: photoBackground(collection.cover) }}
            onClick={() => onOpenCollection(collection.id)}
          >
            <div className="photo-collection-card__scrim" />
            <span className="photo-collection-card__pill">{collection.count} PHOTOS</span>
            <div className="photo-collection-card__body">
              <div className="photo-collection-card__title">{collection.title}</div>
              <div className="photo-collection-card__subtitle">{collection.subtitle}</div>
              <div className="photo-collection-card__cta">
                ENTER COLLECTION <span aria-hidden="true">→</span>
              </div>
            </div>
          </button>
        ))}
      </div>

      <CollectionsComingSoonOverlay />
    </section>
  );
}
